// extracted by mini-css-extract-plugin
export default {"heading":"Header_heading__qeuNE","userMenu":"Header_userMenu__vkiVX","userMenuCaption":"Header_userMenuCaption__ZEbUa"};